import axios from 'axios'
//import twitterAPI from 'node-twitter-api'
//import hmacsha1 from 'hmacsha1'

export const twitterOauth = async (twitterStatus, msg) => {
  let accessToken = localStorage.getItem('twitterAccessToken');
  let oauthTokenSecret = localStorage.getItem('twitterAccessTokenSecret');
  let userData = localStorage.getItem('TwitterUserData');
  if (!accessToken || !userData) {
    let response = await axios.post(
      "http://192.168.43.34:3002/",
      {
        "header": {
          "oauth_consumer_key": "Di1CDaJihu3unQm5Fer9oXv6d ",
          "oauth_consumer_secreat": "dYPrI91P7aAvlABCwf1y9a7jgni21LqZVbHHqScNZu06Xd2F25"
        }
      }
    )
      .catch(
        ({ response = {} }) => {
          console.log("fake Api failed :", response);
        }
      )
    if (response && response.data && response.data.url && response.data.oauth_token) {
      console.log("response from server", response.data);
      let callCount = 0;
      let index, verifier;
      let childWindow = window.open(response.data.url, "_blank");

      if (window.cordova) {
        childWindow.addEventListener(
          'loadstart',
          (event) => {
            console.log("loadstart event", event.url);
            index = event.url.indexOf('oauth_verifier');
            if (index > 0) {
              verifier = event.url.substring(index + 15, index + 47);
              console.log("cordova verifier", verifier);
              childWindow.close();
              fetchAccessToken(response.data.oauth_token, verifier, response);
            }
          }
        )
      } else {
        let clearIn = setInterval(
          () => {
            try {
              callCount++;
              if (callCount > 300) {
                window.clearInterval(clearIn);
              }
              if (childWindow.location.origin === "http://localhost:3000") {
                index = childWindow.location.href.indexOf('oauth_verifier')
                if (index > 0) {
                  verifier = childWindow.location.href.substring(index + 15, index + 47);
                  //console.log("childWindow.location.href",childWindow.location.href)
                  console.log("verifier", verifier);
                  window.clearInterval(clearIn);
                  childWindow.close();
                  fetchAccessToken(response.data.oauth_token, verifier, response);
                }
              }
            } catch (e) {
              console.log(e);
            }
          },
          500);
      }
    }

    async function fetchAccessToken(oauthToken, verifier, response) {
      if (oauthToken && verifier) {
        console.log("fetchAccessToken", oauthToken, verifier)
        let res = await axios.post(
          "http://192.168.43.34:3002/fetch",
          {
            "header": {
              "oauth_consumer_key": "Di1CDaJihu3unQm5Fer9oXv6d ",
              "oauth_consumer_secreat": "dYPrI91P7aAvlABCwf1y9a7jgni21LqZVbHHqScNZu06Xd2F25",
              "oauth_verifier": verifier,
              'oauth_token': oauthToken,
              'oAuth_Token_Secret': response.data.oAuthTokenSecret
            }
          }
        )
          .catch(
            ({ response = {} }) => {
              console.log("fake access token Api failed :", response);
            }
          )
        if (res) {
          userData = JSON.parse(res.data.user_data)
          accessToken = res.data.access_token
          oauthTokenSecret = res.data.oauth_token_secret
          localStorage.setItem('twitterAccessToken', accessToken);
          localStorage.setItem('TwitterUserData', res.data.user_data);
          localStorage.setItem('twitterAccessTokenSecret', oauthTokenSecret);
          console.log("accesstoken", accessToken);
          console.log("oauth_token_secret", oauthTokenSecret);
          console.log("res", userData);
          if (twitterStatus) {
            twitterPost(msg);
          }
        }
      }
    }
  } else {
    console.log("twitter data is in local store");
  }
}

export const twitterPost = async (msg) => {
  let accessToken = localStorage.getItem('twitterAccessToken');
  let oauthTokenSecret = localStorage.getItem('twitterAccessTokenSecret');
  console.log("twitter post");
  if (accessToken && oauthTokenSecret) {
    let res = await axios.post(
      "http://192.168.43.34:3002/tweet",
      {
        "header": {
          "twitterAccessToken": accessToken,
          "twitterAccessTokenSecret": oauthTokenSecret,
          "msg": msg
        }
      }
    )
      .catch(
        ({ response = {} }) => {
          console.log("fake access token Api failed post failed:", response);
        }
      )
  } else {
    console.log("there are no twitter token. get one first");
    twitterOauth(true, msg);
  }
}
/*
  let timestamp = Math.round(Date.now() / 1000);
  let signature = signatureDoc();
  let data = {}
  data = await axios.post(
    `https://api.twitter.com/oauth/request_token`,
    {
      "header": {
        "Authorization":
          `oauth_callback=http://localhost:3000,
        OAuth oauth_consumer_key=AB4RIVv9NOtAXVR5un7EkXd59,
        oauth_nonce=u9Yh1p0wAxeAItfYjiXT0GL0HtavVnLh5szYijoW1CrNlRzgmD,
        oauth_signature=${signature},
        oauth_signature_method=HMAC-SHA1,
        oauth_timestamp=${timestamp},
        oauth_version=1.0`
      }
    }
  )
    .catch(
      (response) => {
        console.log("Twitter API failed with the status code:", response);
      }
    )
  console.log("data.data", data);
  if (data) {
    data = JSON.stringify(data.data);
    console.log("data", data);
    //localStorage.setItem("guestInstaProfile", data);
  } else {
    console.log("instagram profile response without data", data);
  }
}

function signatureDoc() {

}


export async function twi() {
  console.log("twi called")
  let rt = await look()
  /*let twitter = new twitterAPI({
    consumerKey: 'AB4RIVv9NOtAXVR5un7EkXd59,',
    consumerSecret: 'u9Yh1p0wAxeAItfYjiXT0GL0HtavVnLh5szYijoW1CrNlRzgmD',
    callback: 'http://localhost:3000'
  });

  twitter.getRequestToken(function (error, requestToken, requestTokenSecret, results) {
    if (error) {
      console.log("Error getting OAuth request token : " + error);
    } else {
      //store token and tokenSecret somewhere, you'll need them later; redirect user
      console.log("data from twitter requestToken", requestToken);
    }
  });
}

function look() {
  let resp
  let url = encodeURIComponent("https://api.twitter.com/oauth/request_token");
  let nonce = Math.random().toString(36).replace(/[^a-z]/, '').substr(2);
  let timestamp = Math.round(Date.now() / 1000);
  let remain = `oauth_consumer_key=AB4RIVv9NOtAXVR5un7EkXd59&oauth_nonce=${nonce}&oauth_signature_method=HMAC-SHA1&oauth_timestamp=${timestamp}&oauth_version=1.0`
  remain = encodeURIComponent(remain);
  let signatureBase = `POST&${url}&${remain}`
  let signingKey = encodeURIComponent("u9Yh1p0wAxeAItfYjiXT0GL0HtavVnLh5szYijoW1CrNlRzgmD")
  signingKey = `${signingKey}&`
  let oauthSignature = hmacsha1(signingKey, signatureBase);
  oauthSignature = encodeURIComponent(oauthSignature);

   fetch('https://api.twitter.com/oauth/request_token', {
    method: 'POST',
    headers: {
       Oauth: {
          oauth_consumer_key: 'AB4RIVv9NOtAXVR5un7EkXd59',
          oauth_nonce: nonce,
          oauth_signature: oauthSignature,
          oauth_signature_method: 'HMAC-SHA1',
          oauth_timestamp: timestamp,
          oauth_version: '1.0'
       }
    }
 })
    .then(
       (res) => {res.json()
       resp= res}
    )
    .then((json) => {
       console.log(json);
    })
*/